import type { BadgeProps } from '@nuxt/ui'
import type { InvoiceRunStatus, InvoiceStatus } from '@/types'

export function settlementMonth(value: string): string {
  return value.slice(0, 7)
}

export function statusLabel(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

const INVOICE_STATUS_COLORS: Record<InvoiceStatus, BadgeProps['color']> = {
  draft: 'neutral',
  finalized: 'primary',
  paid: 'success',
  void: 'error',
}

export function invoiceStatusColor(value: InvoiceStatus): BadgeProps['color'] {
  return INVOICE_STATUS_COLORS[value] ?? 'neutral'
}

const INVOICE_RUN_STATUS_COLORS: Record<InvoiceRunStatus, BadgeProps['color']> = {
  running: 'neutral',
  completed: 'success',
  failed: 'error',
}

export function invoiceRunStatusColor(value: InvoiceRunStatus): BadgeProps['color'] {
  return INVOICE_RUN_STATUS_COLORS[value] ?? 'neutral'
}
